module.exports = function isString(x) {
  return typeof x === 'string';
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/tcomb-form/~/tcomb/lib/isString.js
 ** module id = 167
 ** module chunks = 0
 **/